import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  List,
  Grid,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@mui/material/Slide";
import CircleIcon from "@mui/icons-material/Circle";
import IconButton from "@mui/material/IconButton";
import { unicodeToString } from "../../Js/Common";

const style = {
  width: 600,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};
const UXAudio = new Audio();

const VideoRecPopup = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  const classes = useStyles();
  // Load Dynamic Image

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
    return () => {
      UXAudio.pause();
      UXAudio.currentTime = 0;
    };
  }, []);

  const UXEffect = (src) => {
    if (!initialRender && props.visible && props.UX) {
      UXAudio.src = src;
      UXAudio.play();
    }
  };

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          border: "0px !important",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "primary.main",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                px: 4,
              }}
            >
              <Grid item>
                {props.primaryText && (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "center",
                      mt: 3,
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    {props.primaryText}
                  </Typography>
                )}
              </Grid>
              <Grid item sx={{ justifyContent: "center", width: "100%" }}>
                {props.options &&
                  props.options.map((val, index) => {
                    return (
                      <List
                        dense
                        sx={{
                          border: 1,
                          borderRadius: 10,
                          borderColor: "#FFF",
                          padding: "0.2em",
                          my: 2,
                          margin: "0.5em",
                        }}
                      >
                        <ListItem
                          sx={{ pa: 0 }}
                          secondaryAction={
                            <>
                              <IconButton
                                edge="end"
                                aria-label="select"
                                onClick={() => {
                                  props.setSelectedOptionIndex(index);
                                }}
                              >
                                <CircleIcon
                                  fontSize="small"
                                  value="a"
                                  name="radio-buttons"
                                  sx={{
                                    color:
                                      props.selectedOption == index
                                        ? "#FFFFFF"
                                        : "#DB8829",
                                    border:
                                      props.selectedOption == index ? 2 : 2,
                                    borderColor: "#FFFFFF",
                                    borderRadius: "50%",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.4rem",
                                    },
                                  }}
                                />
                              </IconButton>
                            </>
                          }
                        >
                          <ListItemText
                            classes={{ primary: classes.ListItemText }}
                            sx={{ color: "#FFF", pl: 1 }}
                          >
                            {val && val.text && (
                              <Typography
                                sx={{
                                  width: "calc(70%)",
                                  fontWeight: "500",
                                  fontSize: "0.9rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                              >
                                {unicodeToString(val.text)}
                              </Typography>
                            )}
                          </ListItemText>
                        </ListItem>
                      </List>
                    );
                  })}
              </Grid>
              <Button
                onClick={() => {
                  props.confirm();
                }}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 10,
                  backgroundColor: "#FFF",
                  color: "primary.main",
                  fontWeight: "bold",
                  
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                  mt: 3,
                  px: 9,
                }}
                disabled={props.selectedOption < 0}
              >
                {props.confirmText}
              </Button>
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
  ListItemText: {
    fontSize: "1rem",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
});
export default VideoRecPopup;
